<template>
  <div class="legal-page">
    <h1 class="legal-title">Politique de confidentialité</h1>

    <section class="legal-section">
      <h2 class="legal-subtitle">Données collectées</h2>
      <p>
        CrossFit Event Scanner collecte des données de navigation anonymes via
        <strong>Google Analytics</strong> (pages visitées, durée de session,
        pays d'origine) afin d'améliorer le service. Ces données ne permettent
        pas d'identifier personnellement les visiteurs.
      </p>
      <p>
        Si vous vous connectez via <strong>Supabase Auth</strong>, votre adresse
        e-mail est stockée pour vous permettre d'accéder aux fonctionnalités
        réservées aux administrateurs. Aucune donnée personnelle n'est partagée
        avec des tiers à des fins commerciales.
      </p>
    </section>

    <section class="legal-section">
      <h2 class="legal-subtitle">Cookies</h2>
      <p>
        Ce site utilise des cookies de mesure d'audience (Google Analytics) et
        des cookies de session (Supabase Auth). Vous pouvez désactiver les
        cookies analytiques via les paramètres de votre navigateur sans impact
        sur la navigation.
      </p>
    </section>

    <section class="legal-section">
      <h2 class="legal-subtitle">Vos droits (RGPD)</h2>
      <p>
        Conformément au Règlement Général sur la Protection des Données (RGPD),
        vous disposez d'un droit d'accès, de rectification et de suppression de
        vos données personnelles. Pour exercer ces droits, contactez-nous à
        l'adresse suivante :
        <!-- <a href="mailto:rob.fermaud@gmail.com">rob.fermaud@gmail.com</a>. -->
      </p>
    </section>
  </div>
</template>

<script setup lang="ts">
definePageMeta({ layout: 'search' });
useSeoMeta({
  title: 'Politique de confidentialité — CrossFit Event Scanner',
  robots: 'noindex',
});
</script>
